module.exports = "/images/upload-file.svg?514191cf6b5890641d81b8fba47de6ad";